'use client';

import React__default from 'react';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import { PricingInfoWrapper, Text, PricingInfoContainer, ImageWrapper, PricingInfoSection, LimitTextLine, CompanyText, SalaryText, List, PricingSection, PricingText, FreeTrialText } from './styles.js';
import '../../Images/AddIcon/index.js';
import '../../Images/AddOutlinedIcon/index.js';
import '../../Images/Trash/index.js';
import '../../Images/Pencil/index.js';
import '../../_virtual/_tslib.js';
import '../../Images/ArrowRoundedLeft/index.js';
import '../../Images/ArrowRoundedRight/index.js';
import '../../Images/AwardsIcon/index.js';
import '../../Images/BonusIcon/index.js';
import '../../Images/CanteenIcon/index.js';
import '../../Images/CheckTagIcon/index.js';
import '../../Images/CommercialIcon/index.js';
import '../../Images/CompanySizeIcon/index.js';
import '../../Images/ContactIcon/index.js';
import '../../Images/CopyIcon/index.js';
import '../../Images/DefaultAvatar/index.js';
import '../../Images/DangerIcon/index.js';
import '../../Images/ExternalLinkIcon/index.js';
import '../../Images/FacebookIcon/index.js';
import '../../Images/ForwardIcon/index.js';
import '../../Images/HealthcarePlanIcon/index.js';
import '../../Images/HeartIcon/index.js';
import '../../Images/HeartOutlineIcon/index.js';
import '../../Images/HideIcon/index.js';
import '../../Images/KindergartenIcon/index.js';
import '../../Images/LaptopIcon/index.js';
import '../../Images/LibraryIcon/index.js';
import '../../Images/LinkIcon/index.js';
import '../../Images/LinkedInIcon/index.js';
import '../../Images/LoadingCircleIcon/index.js';
import '../../Images/MarkerIcon/index.js';
import '../../Images/MobileIcon/index.js';
import '../../Images/PaidLeaveIcon/index.js';
import '../../Utils/constants.js';
import '../../Images/SearchIcon/index.js';
import '../../Images/ShareIcon/index.js';
import '../../Images/ReportIcon/index.js';
import '../../Images/StatsIcon/index.js';
import '../../Images/TeamActivitiesIcon/index.js';
import '../../Images/ThreeDotIcon/index.js';
import '../../Images/TrainingIcon/index.js';
import '../../Images/TransportationIcon/index.js';
import '../../Images/TrashIcon/index.js';
import '../../Images/TravelOpportunitiesIcon/index.js';
import '../../Colors/index.js';
import '../../Images/VerticalMoreIcon/index.js';
import '../../Images/VoucherIcon/index.js';
import '../../Images/WowCVIcon/index.js';
import '../../Images/WorkingLocationIcon/index.js';
import '../../Images/ZaloIcon/index.js';
import '../../Images/FacebookLogoIcon/index.js';
import '../../Images/GoogleLogoIcon/index.js';
import '../../Images/DragReorderIcon/index.js';
import '../../Images/CheckIcon/index.js';
import '../../Images/CircleChecked/index.js';
import '../../Images/SalaryIcon/index.js';
import '../../Images/BriefcaseIcon/index.js';
import '../../Images/GraduationCapIcon/index.js';
import '../../Images/EnvelopeIcon/index.js';
import '../../Images/AddFilledIcon/index.js';
import '../../Images/HomeIcon/index.js';
import '../../Images/PhoneIcon/index.js';
import '../../Images/AttachIcon/index.js';
import '../../Images/FilterIcon/index.js';
import AIStarListIcon from '../../Images/AIStarListIcon/index.js';
import AISalaryIcon from '../../Images/AISalaryIcon/index.js';
import '../../icons/WarnIcon.js';
import '../../icons/AccountSettingsIcon.js';
import '../../icons/DashboardIcon.js';
import '../../icons/JobAlertsIcon.js';
import '../../icons/MyCompaniesIcon.js';
import '../../icons/MyJobsIcon.js';
import '../../icons/MyProfileIcon.js';
import '../../icons/ProfileSettingsIcon.js';
import '../../icons/LanguageIcon.js';
import '../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../icons/BenefitGroupIcons/Physics.js';
import '../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../icons/AccountCenterGroupIcons/Language.js';
import '../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../icons/InfoOverviewGroupIcons/Location.js';
import '../../icons/InfoOverviewGroupIcons/Education.js';
import '../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../icons/InfoOverviewGroupIcons/Address.js';
import '../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../icons/MiscGroupIcons/Link.js';
import '../../icons/MiscGroupIcons/History.js';
import '../../icons/MiscGroupIcons/Favorite.js';
import '../../icons/MiscGroupIcons/UnFavorite.js';
import '../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../icons/MiscGroupIcons/Star.js';
import '../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../icons/SocialMediaGroupIcons/Share.js';
import '../../icons/NavigationGroupIcons/Vertical.js';
import '../../icons/NavigationGroupIcons/More.js';
import '../../icons/NavigationGroupIcons/Close.js';
import '../../icons/NavigationGroupIcons/Expand.js';
import '../../icons/NavigationGroupIcons/Collapse.js';
import '../../icons/NavigationGroupIcons/Next.js';
import '../../icons/NavigationGroupIcons/Back.js';
import '../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../icons/NavigationGroupIcons/RightArrow.js';
import '../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../icons/AlertGroupIcons/CareerPath.js';
import '../../icons/AlertGroupIcons/Hot.js';
import '../../icons/AlertGroupIcons/Urgent.js';
import '../../icons/FormActionGroupIcons/Exchange.js';
import '../../icons/FormActionGroupIcons/AddTag.js';
import '../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../Images/DoubleTickIcon/index.js';
import '../../Images/BellIcon/index.js';
import '../../Images/AiIcon/index.js';
import '../../Images/MiniAiIcon/index.js';
import '../../icons/OrderManagementIcon.js';
import '../../Images/TwinkleLinearGradientIcon/index.js';

var DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
function PricingInfo(_a) {
    var _b;
    var job = _a.job, t = _a.t, numsOfTrial = _a.numsOfTrial;
    var _c = job !== null && job !== void 0 ? job : {}, _d = _c.companyLogo, companyLogo = _d === void 0 ? '' : _d, _e = _c.jobTitle, jobTitle = _e === void 0 ? '' : _e, _f = _c.jobUrl, jobUrl = _f === void 0 ? '' : _f, _g = _c.companyName, companyName = _g === void 0 ? '' : _g, _h = _c.prettySalary, prettySalary = _h === void 0 ? '' : _h;
    // variables
    var isTrial = numsOfTrial > 0;
    return (React__default.createElement(PricingInfoWrapper, null,
        React__default.createElement(Row, { gutter: [16, 0] },
            React__default.createElement(Col, null,
                React__default.createElement(Text, null, t('Evaluated for the position of'))),
            React__default.createElement(Col, null,
                React__default.createElement(PricingInfoContainer, null,
                    React__default.createElement(ImageWrapper, null,
                        React__default.createElement("img", { src: companyLogo || DEFAULT_COMPANY_LOGO, alt: (_b = job === null || job === void 0 ? void 0 : job.jobTitle) !== null && _b !== void 0 ? _b : '' })),
                    React__default.createElement(PricingInfoSection, null,
                        React__default.createElement("a", { href: jobUrl, target: '_blank', rel: 'noreferrer' },
                            React__default.createElement(LimitTextLine, { limitLine: 2, className: 'section-title' }, jobTitle)),
                        React__default.createElement(CompanyText, null, companyName),
                        React__default.createElement(LimitTextLine, null,
                            React__default.createElement(SalaryText, null, prettySalary))))),
            React__default.createElement(Col, null,
                React__default.createElement(Text, null, t('Maximize your competitive advantage with VietnamWorks AI'))),
            React__default.createElement(Col, null,
                React__default.createElement(List, null,
                    React__default.createElement("li", null,
                        React__default.createElement(AIStarListIcon, null),
                        t("Assess matching rate from employer's viewpoint")),
                    React__default.createElement("li", null,
                        React__default.createElement(AIStarListIcon, null),
                        t('Suggest to improve the matching')),
                    React__default.createElement("li", null,
                        React__default.createElement(AIStarListIcon, null),
                        t('Analyze the profiles of applicants')),
                    React__default.createElement("li", null,
                        React__default.createElement(AIStarListIcon, null),
                        t('Check salary reference and hiring demand')))),
            React__default.createElement(Col, null,
                React__default.createElement(PricingSection, null,
                    React__default.createElement(PricingText, null,
                        React__default.createElement("p", null,
                            t('Price'),
                            ' ',
                            React__default.createElement("strong", { className: 'highlight', style: { textDecorationLine: isTrial ? 'line-through' : undefined } },
                                "29.000",
                                React__default.createElement("u", null, "\u0111"),
                                " / ",
                                t('time'))),
                        isTrial ? (React__default.createElement(FreeTrialText, null,
                            React__default.createElement("span", { className: 'highlight' },
                                "0",
                                React__default.createElement("u", null, "\u0111")),
                            ' ',
                            React__default.createElement(AISalaryIcon, null))) : null),
                    isTrial ? (React__default.createElement(PricingText, null, t('You have {0} free trial').replace('{0}', numsOfTrial.toString()))) : null)))));
}

export { PricingInfo as default };
//# sourceMappingURL=index.js.map
